/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionDetailed } from './SubscriptionDetailed';
import {
    SubscriptionDetailedFromJSON,
    SubscriptionDetailedFromJSONTyped,
    SubscriptionDetailedToJSON,
    SubscriptionDetailedToJSONTyped,
} from './SubscriptionDetailed';

/**
 * 
 * @export
 * @interface GetBillingStripeSubscriptionStatusFromStripe200Response
 */
export interface GetBillingStripeSubscriptionStatusFromStripe200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetBillingStripeSubscriptionStatusFromStripe200Response
     */
    hasActiveSubscription?: boolean;
    /**
     * Whether the company has a payment method (card) on file. Required to run comparison/supplement features.
     * @type {boolean}
     * @memberof GetBillingStripeSubscriptionStatusFromStripe200Response
     */
    hasPaymentMethod?: boolean;
    /**
     * 
     * @type {SubscriptionDetailed}
     * @memberof GetBillingStripeSubscriptionStatusFromStripe200Response
     */
    subscription?: SubscriptionDetailed;
}

/**
 * Check if a given object implements the GetBillingStripeSubscriptionStatusFromStripe200Response interface.
 */
export function instanceOfGetBillingStripeSubscriptionStatusFromStripe200Response(value: object): value is GetBillingStripeSubscriptionStatusFromStripe200Response {
    return true;
}

export function GetBillingStripeSubscriptionStatusFromStripe200ResponseFromJSON(json: any): GetBillingStripeSubscriptionStatusFromStripe200Response {
    return GetBillingStripeSubscriptionStatusFromStripe200ResponseFromJSONTyped(json, false);
}

export function GetBillingStripeSubscriptionStatusFromStripe200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBillingStripeSubscriptionStatusFromStripe200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'hasActiveSubscription': json['hasActiveSubscription'] == null ? undefined : json['hasActiveSubscription'],
        'hasPaymentMethod': json['hasPaymentMethod'] == null ? undefined : json['hasPaymentMethod'],
        'subscription': json['subscription'] == null ? undefined : SubscriptionDetailedFromJSON(json['subscription']),
    };
}

export function GetBillingStripeSubscriptionStatusFromStripe200ResponseToJSON(json: any): GetBillingStripeSubscriptionStatusFromStripe200Response {
    return GetBillingStripeSubscriptionStatusFromStripe200ResponseToJSONTyped(json, false);
}

export function GetBillingStripeSubscriptionStatusFromStripe200ResponseToJSONTyped(value?: GetBillingStripeSubscriptionStatusFromStripe200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hasActiveSubscription': value['hasActiveSubscription'],
        'hasPaymentMethod': value['hasPaymentMethod'],
        'subscription': SubscriptionDetailedToJSON(value['subscription']),
    };
}

